import React from 'react';
import { motion } from 'framer-motion';
import { IoCart } from 'react-icons/io5';
import './Shop.css';

export default function Shop() {
  return (
    <div className="page shop-page">
      <div className="shop-coming-soon">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ type: 'spring', stiffness: 200, damping: 20 }}
          className="shop-coming-content"
        >
          <span className="shop-coming-icon">🛍️</span>
          <h1 className="shop-coming-title">Boutique</h1>
          <p className="shop-coming-text">
            La boutique Plumly arrive bientôt ! Tu pourras y dépenser tes plumes pour personnaliser ton profil, débloquer des thèmes de lecture et bien plus.
          </p>
          <div className="shop-coming-badge">
            <IoCart /> Bientôt disponible
          </div>
        </motion.div>
      </div>
    </div>
  );
}